import { useSelector } from "react-redux";

import { getPreviewCatalogModalDetail } from "@helpers/catalog";

import ProductDetailsModal from "@components/store/product-details-modal";

import { useModal } from "@stadium/hooks/lib/use-modal";

import { getIsPricelessShop } from "@selectors/store";

import { PRODUCT_DETAILS_MODAL } from "@constants/modal-types";

import styles from "./main.module.scss";

const useProductDetailsModal = () => {
  const isPricelessShop = useSelector(getIsPricelessShop);

  const { openModal: openProductDetailsModalCatalog, renderModal } = useModal(
    PRODUCT_DETAILS_MODAL,
    ProductDetailsModal,
  );

  const renderProductDetailsModalCatalog = ({ data }) =>
    renderModal({
      classes: {
        rootClass: styles.productDetailsCatalogPrimaryModal,
        dialogClass: `${styles.modalDialogCatalogProductDetails} ${styles.revampDesign}`,
      },
      data: {
        ...getPreviewCatalogModalDetail(data),
        ...(isPricelessShop
          ? { renderCatalogModeFooterLinks: () => null, viewOnlyMode: true }
          : {}),
        classes: {
          productImgClass: styles.catalogModeImgSection,
          productContentClass: styles.catalogModeContentClass,
        },
      },
    });

  return { renderProductDetailsModalCatalog, openProductDetailsModalCatalog };
};

export default useProductDetailsModal;
